import React from 'react';
import Checkbox from '../../../../common/Checkbox';

const getColumns = (t) => ({
  name: {
    accessor: 'name',
    Header: t('settings:taxes.column_tax_name'),
  },
  percentage: {
    accessor: 'percentage',
    Header: t('settings:taxes.column_percentage'),
  },
  shops: {
    accessor: 'shops',
    Header: t('settings:taxes.column_shops'),
  },
  addToPrice: {
    accessor: 'addToPrice',
    Header: t('settings:taxes.column_add_to_price'),
    Cell: (row) => <Checkbox checked={row.value} readOnly />,
  },
  externalOrdersOnly: {
    accessor: 'externalOrdersOnly',
    Header: t('settings:taxes.column_external_orders_only'),
    Cell: (row) => <Checkbox checked={row.value} readOnly />,
  },
  enabled: {
    accessor: 'enabled',
    Header: t('settings:taxes.column_enabled'),
    Cell: (row) => <Checkbox checked={row.value} readOnly />,
  },
});

export default getColumns;
